import React, { PropsWithChildren, useState } from 'react';

import crashlytics from 'features/observability/crashlytics';

import ActionButton from 'components/action-button';
import IconError from 'components/error-boundary-static/icon';
import { useReload } from 'components/error-boundary-static/use-reload';
import { LogUserErrorSeverity, logUserErrorMessage } from 'hooks/log-user-error-message';
import { useRoute } from 'hooks/navigation/use-route';
import useEffectOnce from 'hooks/use-effect-once';
import { t } from 'state/intl/translations';
import logger from 'utils/logger';

import { Container, Header, Inner } from './styles';

type BlankScreenLoggerProps = PropsWithChildren<{
  context: {
    reason: string;
    [key: string]: any;
  };
  onReload?: () => void;
}>;

export const BlankScreen = ({ context, children, onReload }: BlankScreenLoggerProps) => {
  const route = useRoute();
  const [hasAppBeenReloaded, setHasAppBeenReloaded] = useState(false);
  const message = `[BlankScreen] Screen pathname: ${route.pathname}`;

  const handleReload = useReload(() => {
    if (!hasAppBeenReloaded && onReload) {
      onReload();
      setHasAppBeenReloaded(true);
      return;
    }

    crashlytics().log(message);
    crashlytics().crash();
  });

  useEffectOnce(() => {
    logger.warn({
      message,
      context: {
        ...context,
        route,
      },
    });
    logUserErrorMessage({
      message,
      severity: LogUserErrorSeverity.Recoverable,
      context: {
        moreInfo: 'blank-screen.tsx',
        ...context,
      },
    });
  });

  if (children) {
    return <>children</>;
  }

  return (
    <Container>
      <Inner>
        <IconError />
        <Header>
          {t('loyaltyUnavailableInRegionOops')} {t('somethingWrong')}
        </Header>
        <ActionButton onPress={handleReload}>{t('reload')}</ActionButton>
      </Inner>
    </Container>
  );
};
